import { DiscordLogo, FacebookLogo, LinkedinLogo } from '@phosphor-icons/react'
import type { SocialLink } from '@/content/schema'

/** Glyph for a social link: Phosphor brand icons, and the HL Accelerator and Diskarte Digital logos
 *  (no Phosphor glyph exists). Diskarte has one file per theme (scripts/make-diskarte-mark.py). */
export function SocialIcon({ icon, size = 20 }: { icon: SocialLink['icon']; size?: number }) {
  switch (icon) {
    case 'facebook':
      return <FacebookLogo size={size} weight="fill" aria-hidden />
    case 'linkedin':
      return <LinkedinLogo size={size} weight="fill" aria-hidden />
    case 'discord':
      return <DiscordLogo size={size} weight="fill" aria-hidden />
    case 'hl-accelerator':
      return <img src="/images/badges/64/hl-accelerator.webp" alt="" width={size} height={size} />
    case 'diskarte':
      return (
        <>
          <img className="only-light" src="/images/badges/64/diskarte-digital-light.webp" alt="" width={size} height={size} />
          <img className="only-dark" src="/images/badges/64/diskarte-digital.webp" alt="" width={size} height={size} />
        </>
      )
  }
}
